module.exports = __webpack_public_path__ + "static/media/CTLI_9-444w.dd91a511.jpg";